const parseJsonStringSafely = (value, fallback) => {
  try {
    if (!value)
      return fallback || void 0;
    return JSON.parse(value);
  } catch (e) {
    return fallback || void 0;
  }
};
const normalizeText = (text, withoutSpaces = false) => {
  let str = text.toLowerCase().trim();
  str = str.replace(/\s+/g, withoutSpaces ? "" : " ");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  return str;
};

export { normalizeText, parseJsonStringSafely };
